<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h5 class="info-text">¿Sobre qué producto deseas informarnos?</h5>
      </div>
      <div class="md-layout-item md-layout md-size-100 md-alignment-center-space-around">
        <div class="type-selector">
          <md-button
            class="md-primary btn-selector"
            :class="getButtonClass(1)"
            @click="checkEnvoltorio('conEnvoltorio')"
          >Conservo el envoltorio</md-button>
          <md-button
            class="md-primary btn-selector"
            :class="getButtonClass(2)"
            @click="checkEnvoltorio('sinEnvoltorio')"
          >He perdido el envoltorio</md-button>
        </div>
      </div>
      <div
        class="md-layout-item md-layout md-size-100 md-alignment-center-left"
        v-if="this.envoltorio=='conEnvoltorio'"
      >
        <div class="md-subheading md-layout-item md-size-100">
          <h4>Indicanos el número de lote del producto</h4>
          <h4>
            Si no encuentra el número de lote o no está legible, seleccione la opción
            <strong>He perdido el envoltorio</strong>
          </h4>
        </div>
        <div class="md-layout-item md-size-33">
          <img src="/panel-reclamaciones/img/lote_300x186.jpg" class="image_lote" />
        </div>
        <div class="md-layout-item md-size-66 ml-auto mt-4 md-small-size-100">
          <md-field
            :class="[
          {'md-valid': !errors.has('lote') && touched.lote},
          {'md-error': errors.has('lote')}]"
          >
            <md-icon>L</md-icon>
            <label>Numero de lote</label>
            <md-input
              v-model="product.lote"
              data-vv-name="lote"
              type="text"
              name="lote"
              required
              maxlength="8"
              @keypress.stop="preventNumericInput"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="error_list.indexOf('lote') > -1">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!error_list.indexOf('lote') > -1 && touched.lote"
              >done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>
      <div
        class="md-layout-item md-layout md-size-100 md-alignment-center-space-around"
        v-if="this.envoltorio=='sinEnvoltorio'"
      >
        <div class="md-layout-item md-size-100">
          <h4>Selecciona el producto de la lista</h4>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="categories"
            :auto-hide="true"
            @selected="onSelectedCategoria"
            placeholder="Selecciona el tipo de producto"
            :error="getError('categoria')"
          ></ht-select>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="products"
            :auto-hide="true"
            :disabled="productDisabled"
            @selected="onSelectedProduct"
            placeholder="Selecciona el producto"
            :error="getError('producto')"
          ></ht-select>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-33" v-if="product.type != null">
          <img :src="getProductImage()" class="image-product" />
        </div>
      </div>
      <div
        class="md-layout-item md-layout md-size-100 localizacion-container"
        v-if="product.selected || (product.lote!=null && product.lote!='' && product.lote.length == 8)"
      >
        <div class="md-layout-item md-size-100 md-small-size-100" v-if="product.selected">
          <md-datepicker v-model="product.caducidad" md-immediately>
            <label>Si recuerda la fecha aproximada de caducidad del producto, díganosla por favor</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="provincias"
            :auto-hide="true"
            @selected="onSelectedProvicia"
            placeholder="Indica la provincia donde fue adquirido"
          ></ht-select>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="poblaciones"
            :auto-hide="true"
            :disabled="poblacionesDisabled"
            @selected="onSelectedPoblacion"
            placeholder="Indica el municipio donde fue adquirido"
          ></ht-select>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="cadenas"
            :auto-hide="true"
            @selected="onSelectedCadena"
            :disabled="cadenaDisabled"
            placeholder="Indica la cadena donde fue adquirido"
            ref="cbCadenas"
          ></ht-select>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
          <ht-select
            :list="comercios"
            :auto-hide="true"
            @selected="onSelectedComercio"
            :disabled="comercioDisabled"
            placeholder="Indica el comercio donde fue adquirido"
            ref="cbComercios"
          >
            <template slot-scope="{row}">{{ row.name }}</template>
          </ht-select>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { SlideYDownTransition } from "vue2-transitions";
import { Autocomplete, HtSelect } from "@/components";
import { apiServer, staticServer } from "@/globalVars.js";

export default {
  name: "StepProduct",
  components: { SlideYDownTransition, Autocomplete, HtSelect },
  props: {
    product: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      envoltorio: "nodefinido",
      products: [],
      categories: [],
      provincias: [],
      poblaciones: [],
      cadenas: [],
      comercios: [],
      poblacionesDisabled: true,
      cadenaDisabled: true,
      comercioDisabled: true,
      productDisabled: true,
      error_list: [],
      touched: {
        lote: false
      }
    };
  },
  model: {
    event: "next"
  },
  computed: {},
  mounted() {
    this.loadProvincias();
    this.loadCategorias();
  },
  methods: {
    preventNumericInput($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    getButtonClass(button) {
      if (this.envoltorio == "sinEnvoltorio" && button == 2) {
        return "button-selected";
      }

      if (this.envoltorio == "conEnvoltorio" && button == 1) {
        return "button-selected";
      }
      return "";
    },
    checkEnvoltorio(envoltorio) {
      this.envoltorio = envoltorio;
      this.product.envoltorio = envoltorio;
      if (envoltorio == "sinEnvoltorio") {
        this.product.lote = null;
      } else {
        this.product.category = null;
        this.product.type = null;
        this.product.selected = false;
      }
    },
    getError(fieldName) {
      return this.error_list.indexOf(fieldName) > -1;
    },
    validate() {
      this.error_list = [];
      if (this.product.lote == null) {
        if (this.product.category == null) {
          this.error_list.push("categoria");
        }
        if (this.product.type == null) {
          this.error_list.push("producto");
        }
      } else {
        if (this.product.lote.length != 8) {
          this.error_list.push("lote");
        }
      }
      // if (this.product.comercio == null) {
      //   this.error_list.push("comercio");
      // }
      let res = this.error_list.length == 0;
      this.$emit("on-validated", res);
      return res;
    },
    onSelectedComercio(val) {
      this.product.comercio = val;
    },
    onSelectedProvicia(val) {
      let oldValue = this.product.provincia;
      this.product.provincia = val;
      this.poblacionesDisabled = false;
      if (oldValue != val) {
        this.cadenas = [];
        this.comercios = [];
        this.loadPoblaciones();
      }
    },
    onSelectedPoblacion(val) {
      let oldValue = this.product.municipio;
      this.product.municipio = val;
      this.cadenaDisabled = false;
      if (oldValue != val) {
        this.comercios = [];
        this.loadCadenas();
      }
    },
    onSelectedCadena(val) {
      let oldValue = this.product.cadena;
      this.product.cadena = val;
      this.comercioDisabled = false;
      if (oldValue != val) {
        this.loadComercios();
      }
    },
    onSelectedCategoria(val) {
      let oldValue = this.product.category;
      this.product.category = val;
      this.productDisabled = false;
      if (oldValue != val) {
        this.loadProductos();
      }
    },
    onSelectedProduct(val) {
      this.product.selected = true;
      this.product.type = val;
    },
    getProductImage() {
      return staticServer + this.product.type.image;
    },
    loadCategorias() {
      fetch(apiServer + "/categoria")
        .then(response => response.json())
        .then(data => {
          this.categories = data;
        });
    },
    loadProvincias() {
      fetch(apiServer + "/provincia")
        .then(response => response.json())
        .then(data => {
          this.provincias = data;
        });
    },
    loadPoblaciones() {
      fetch(
        apiServer + "/provincia/" + this.product.provincia._id + "/municipio"
      )
        .then(response => response.json())
        .then(data => {
          this.poblaciones = data;
        });
    },
    loadCadenas() {
      fetch(apiServer + "/municipio/" + this.product.municipio._id + "/cadena")
        .then(response => response.json())
        .then(data => {
          this.cadenas = data;
        });
    },
    loadComercios() {
      fetch(
        apiServer +
          "/cadena/" +
          this.product.cadena._id +
          "/municipio/" +
          this.product.municipio._id +
          "/comercio"
      )
        .then(response => response.json())
        .then(data => {
          this.comercios = data;
        });
    },
    loadProductos() {
      fetch(apiServer + "/categoria/" + this.product.category._id + "/producto")
        .then(response => response.json())
        .then(data => {
          this.products = data;
          this.product.selected = false;
          this.product.type = null;
        });
    }
  },
  watch: {
    lote() {
      this.touched.lote = true;
    }
  }
};
</script>


<style scoped>
.localizacion-container {
  margin-top: 40px;
}
.image_lote {
  width: 300px;
  height: 186px;
}
.product-image {
  width: 90px;
  height: 90px;
  margin-right: 5px;
}
.md-list-item {
  margin-right: 5px;
}
.item-content {
  display: flex;
  justify-content: left !important;
}
.button-selected {
  background-color: #004d40 !important;
}
.button-selected:hover {
  background-color: #004d40 !important;
}
.button-selected:active {
  background-color: #004d40 !important;
}
.button-selected:focus {
  background-color: #004d40 !important;
}
.btn-type-selection {
  width: 100%;
  max-width: 100%;
}
.type-selector {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.image-product {
  margin-top: 20px;
  width: 388px;
  height: auto;
  border-radius: 45px;
}
@media (max-width: 992px) {
  .type-selector {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .btn-selector {
    width: 100%;
  }
}
</style>
